import { SvgSempione, SvgAntanaWhite } from '@qadra/frontend-common/svg';

export function getClientConfig(hostname, theme) {
  const defaultBg = theme && theme.colors ? theme.colors.primary : '#000';

  if (!hostname) return { bgColor: defaultBg, Logo: SvgSempione };

  const h = hostname.toLowerCase();

  if (h.includes('qadra.mangrovia.io') || h.includes('qadra2.mangrovia.io')) {
    return { bgColor: '#5A3AEB', Logo: SvgAntanaWhite };
  }

  if (h.includes('sempione')) {
    return { bgColor: defaultBg, Logo: SvgSempione };
  }

  return { bgColor: defaultBg, Logo: SvgSempione };
}

export default getClientConfig;
